// Défi anti-abus par preuve de travail (aucun service tiers) : trouver le plus petit entier n tel que
// SHA-256(« défi:n ») commence par `bits` bits à zéro. Même calcul que l'API (src/ekera/api/defi_travail.py) et que
// l'inscription en libre-service (SS6). Le navigateur fait quelques dizaines de milliers de calculs, en rendant la main
// régulièrement pour que la page reste fluide.

function zerosDeTete(octets: Uint8Array): number {
  let n = 0;
  for (const o of octets) {
    if (o === 0) {
      n += 8;
      continue;
    }
    return n + Math.clz32(o) - 24;
  }
  return n;
}

const encodeur = new TextEncoder();

export async function resoudreDefi(
  defi: string,
  bits: number,
  { limite = 50_000_000, signal }: { limite?: number; signal?: AbortSignal } = {},
): Promise<string> {
  for (let n = 0; n < limite; n += 1) {
    if (signal?.aborted) throw new DOMException('abandon', 'AbortError');
    const condensat = new Uint8Array(await crypto.subtle.digest('SHA-256', encodeur.encode(`${defi}:${n}`)));
    if (zerosDeTete(condensat) >= bits) return String(n);
    if (n % 2000 === 1999) await new Promise((r) => setTimeout(r, 0));
  }
  throw new Error('défi non résolu');
}
